import { loadingSpinner } from "../helpers";

// Shared hover logic
function bindLinkedProductHover(productCard) {
  const imageContainer = productCard.querySelector('.linked-product__image');
  const priceContainer = productCard.querySelector('.js-product-price');
  if (!imageContainer || !priceContainer) return;

  const originalPrice = priceContainer.innerHTML;

  productCard.querySelectorAll('.js-product-colour-swatch').forEach(swatch => {
    if (swatch.dataset.bound === 'true') return;
    swatch.dataset.bound = 'true';

    swatch.addEventListener('mouseenter', function () {
      imageContainer.classList.add('fade-out');
      priceContainer.classList.add('fade-out');

      setTimeout(() => {
        imageContainer.innerHTML = `
          <div class="aspect-3/4 bg-product-card-bg fade">
            <img class="w-full h-full object-cover" src="${this.getAttribute('data-large')}">
          </div>
        `;
        imageContainer.classList.remove('fade-out');
        imageContainer.classList.add('fade-in');
        priceContainer.innerHTML = `<span class="fade">${this.getAttribute('data-price')}</span>`;
        priceContainer.classList.remove('fade-out');
        priceContainer.classList.add('fade-in');
      }, 300);
    });

    swatch.addEventListener('mouseleave', function () {
      imageContainer.classList.add('fade-out');
      priceContainer.classList.add('fade-out');

      setTimeout(() => {
        imageContainer.innerHTML = "";
        imageContainer.classList.remove('fade-in', 'fade-out');
        priceContainer.innerHTML = originalPrice;
        priceContainer.classList.remove('fade-in', 'fade-out');
      }, 300);
    });
  });
}

class ProductCard extends HTMLElement {
  constructor(options) {
    super();

    this.options = Object.assign({
      selectors: {
        variantSelector: ".product-card__selector input",
        selectedVariant: "select#js-selected-variant",
        optionSelectors: ".product-card__selector",
        primaryImage: ".primary-image",
        secondaryImage: ".secondary-image",
      },
      texts: {
        soldOut: "Sold out",
      },
    }, options);

    this.s = this.options.selectors;
    this.t = this.options.texts;

    this.form = this.querySelector("form");
    if (this.form) {
      this.form.addEventListener("submit", this.onSubmitHandler);
    }

    this.init();
  }

  init() {
    this.initSelect();
    this.linkedProductHover();
    this.attachButtonListeners();
  }

  initSelect() {
    this.querySelectorAll(this.s.variantSelector).forEach((el) => {
      el.addEventListener("change", (e) => {
        const values = this.getOptionValues([]);
        const variant = values.join(" / ");
        const variant_selector = this.querySelector(this.s.selectedVariant);

        this.changeVariant(variant, variant_selector);
        this.fetchVariantImage(variant_selector);
      });
    });
  }

  getOptionValues(values) {
    const optionSelectors = this.querySelectorAll(this.s.optionSelectors);

    optionSelectors.forEach((selector, index) => {
      if (index === 0) {
        const option = selector.querySelector("input:checked");
        values.push(option.value);
      } else {
        selector.querySelectorAll("input").forEach((option) => {
          if (option.hasAttribute("checked")) {
            values.push(option.value);
          }
        });
      }
    });

    return values;
  }

  changeVariant(variant, variant_selector) {
    variant_selector.querySelectorAll("option").forEach((option) => {
      if (option.innerText.trim().includes(variant)) {
        variant_selector.value = option.value;
        const evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        variant_selector.dispatchEvent(evt);
      }
    });
  }

  fetchVariantImage(variant) {
    const handle = variant.dataset.productHandle;

    fetch(`${window.Shopify.routes.root}products/${handle}.js`, {
      method: "GET",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((r) => {
        this.changeVariantImage(r, variant);
        this.changeAddToCartCTA(r, variant);
      })
      .catch(console.log);
  }

  changeVariantImage(r, variant) {
    const id = parseInt(variant.value);
    const selectedVariant = r.variants.find((obj) => obj.id === id);
    if (!selectedVariant?.featured_image) return;

    const variantImage = selectedVariant.featured_image.src;
    const primaryImage = this.querySelector(this.s.primaryImage);
    const secondaryImage = this.querySelector(this.s.secondaryImage);

    primaryImage.srcset = variantImage;
    if (secondaryImage) secondaryImage.srcset = variantImage;
  }

  changeAddToCartCTA(r, variant) {
    const id = parseInt(variant.value);
    const selectedVariant = r.variants.find((obj) => obj.id === id);
    const addToCart = this.querySelector(".product-card__button");

    if (!selectedVariant.available) {
      addToCart.value = this.t.soldOut;
      addToCart.classList.add("disabled");
      addToCart.disabled = true;
    } else {
      addToCart.value = "Add to cart";
      addToCart.classList.remove("disabled");
      addToCart.disabled = false;
    }
  }

  attachButtonListeners() {
    this.querySelectorAll('[type="submit"]').forEach((button) => {
      button.addEventListener("click", (event) => {
        loadingSpinner(event.currentTarget);
      });
    });
  }

  linkedProductHover() {
    bindLinkedProductHover(this);
  }
}

customElements.define("product-card", ProductCard);

// Global hover binding for dynamically injected product cards
function linkedProductHoverGlobal() {
  document.querySelectorAll('.product-card').forEach(bindLinkedProductHover);
}

document.addEventListener('DOMContentLoaded', () => {
  linkedProductHoverGlobal();
});

const observer = new MutationObserver(() => {
  linkedProductHoverGlobal();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});